import { render } from "./BestSeller.vue?vue&type=template&id=1ac2677d"
import script from "./BestSeller.vue?vue&type=script&lang=js"
export * from "./BestSeller.vue?vue&type=script&lang=js"

import "./BestSeller.vue?vue&type=style&index=0&id=1ac2677d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__